import enTimeline from "./en";
import frTimeline from "./fr";
import deTimeline from "./de";

export { enTimeline, frTimeline, deTimeline };
